import AjaxRequest from './AjaxRequest';

export default class CallbackHandler {

    handleSuccess(response, prop) {
        // console.log(response);
        // console.log(`Successful ${prop} callback`);
        return this[prop] = response;
    }

    handleError(className, functionName, userMessage, error) {
        // const data = {
        //     jsClass: className,
        //     function: functionName,
        //     error: error,
        // }
        // const api = new AjaxRequest('logError', data);

        // api.postRequest().then(function(response) {
            // console.log('Callback Error:', response);
            // console.log("Error has been logged.");
        // });

        //feedback(userMessage, 'danger');
    }

}
